import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "admin-layout"
};
const _hoisted_2 = {
  class: "admin-header"
};
const _hoisted_3 = {
  class: "admin-brand"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "admin-header-actions"
};
const _hoisted_6 = {
  class: "admin-main"
};
const _hoisted_7 = {
  class: "admin-content"
};
const _hoisted_8 = {
  class: "admin-page-heading"
};
const _hoisted_9 = {
  class: "admin-page-container"
};
import { ref, computed, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/theme-chalk/dark/css-vars.css';
import '@/assets/style/admin-theme.scss';
import { projectGetUserBind } from '@/api/requset/yw/project';
import AdminSidebar from './modules/AdminSidebar.vue';
import WorkspaceMenu from '@/components/WorkspaceMenu.vue';
import AlarmBall from './ht/shaoB/v1/modules/AlarmBall.vue';

// 菜单列表 menu的parentId为null为父菜单，其他菜单根据parentId进行分组

export default {
  __name: 'layout2',
  setup(__props) {
    /** 后台布局，负责导航、路由标题和科技主题的生命周期。 */
    const menuList = JSON.parse(localStorage.getItem('menuList') || '[]');
    const router = useRouter();
    const route = useRoute();
    const userFrom = localStorage.getItem('from');
    const themeRoot = document.documentElement;
    const previousAdminTheme = themeRoot.getAttribute('data-admin-theme');
    const previousDarkMode = themeRoot.classList.contains('dark');
    themeRoot.setAttribute('data-admin-theme', 'sentry');
    themeRoot.classList.add('dark');
    onBeforeUnmount(() => {
      if (previousAdminTheme === null) themeRoot.removeAttribute('data-admin-theme');else themeRoot.setAttribute('data-admin-theme', previousAdminTheme);
      if (!previousDarkMode) themeRoot.classList.remove('dark');
    });

    // 获取Logo图片
    let logoSrc;
    try {
      if (userFrom && userFrom !== 'noLogo') {
        logoSrc = require(`../assets/logo/${userFrom}.png`);
        if (userFrom && userFrom == 'coal') {
          logoSrc = require('../assets/logo/coal2.png');
        }
      } else {
        logoSrc = require('../assets/img/login_logo.png');
      }
    } catch (e) {
      logoSrc = require('../assets/img/login_logo.png');
    }

    // 当前账户名称，缺省时展示“未命名用户”。
    const userName = ref(JSON.parse(localStorage.getItem('userInfo') || '{}').username || '未命名用户');
    // 当前账户头像，空值时使用姓名首字母。
    const userAvatar = ref('');
    // 头像占位字母。
    const userInitials = computed(() => {
      return userName.value ? userName.value.substring(0, 1).toUpperCase() : 'U';
    });

    // 二级菜单列折叠状态，移动端默认收起以保留内容空间。
    const isCollapsed = ref(window.matchMedia('(max-width: 767px)').matches);
    // 从实际路由识别选中菜单，支持刷新和浏览器前进、后退。
    const currentMenu = computed(() => menuList.find(menu => {
      const path = menu.url || (menu.formRouter ? `/ht/${menu.formRouter}` : '');
      return path ? router.resolve(path).path === route.path : (menu.name || menu.menuName || '').toLowerCase() === route.name;
    }));
    // 当前菜单标识，双列菜单统一使用字符串匹配选中项。
    const activeMenu = computed(() => currentMenu.value ? String(currentMenu.value.menuId || currentMenu.value.id) : '');
    // 当前菜单所属分组，用于面包屑与双列菜单的分类同步。
    const parentMenu = computed(() => currentMenu.value?.parentId ? menuList.find(menu => String(menu.menuId || menu.id) === String(currentMenu.value.parentId)) : null);
    // 页面标题优先使用菜单名称，未配置菜单时回退到路由标题。
    const pageTitle = computed(() => currentMenu.value?.name || route.meta.title || '后台首页');
    // 沿用现有页面缓存名单。
    const cachedViews = ref([]);

    /**
     * 判断菜单是否有子菜单
     * @param {Object} menu - 菜单项
     * @returns {Boolean} - 是否有子菜单
     */
    const hasChildren = menu => {
      return menuList.some(item => item.parentId === menu.menuId || item.parentId === menu.id);
    };

    /**
     * 处理菜单选择事件
     * @param {String} index - 选中的菜单索引
     */
    const handleSelect = index => {
      // 在整个菜单列表中查找选中的菜单项
      const selectedMenu = menuList.find(item => String(item.menuId || item.id) === index);
      if (selectedMenu) {
        console.log('选中菜单项:', selectedMenu); // 调试信息

        // 优先使用url字段，如果没有则检查formRouter字段
        if (selectedMenu.url) {
          router.push(selectedMenu.url);
        } else if (selectedMenu.formRouter) {
          // 跳转到/ht/+formRouter路径
          const routePath = `/ht/${selectedMenu.formRouter}`;
          console.log('跳转路径:', routePath); // 调试信息
          router.push(routePath);
        } else {
          // 尝试使用name作为路由名称
          const routeName = selectedMenu.name || selectedMenu.menuName;
          if (routeName) {
            try {
              // 检查是否有对应的路由配置
              router.push({
                name: routeName.toLowerCase()
              });
              console.log('使用名称跳转:', routeName); // 调试信息
            } catch (e) {
              console.error('路由跳转失败:', e);
            }
          }
        }
      }
    };

    /**
     * 获取当前用户绑定项目并缓存，供后台业务页面读取。
     */
    const getUserBindProject = async () => {
      try {
        const result = await projectGetUserBind();
        localStorage.setItem('userBindProject', JSON.stringify(result.data));
      } catch (error) {
        ElMessage.error('获取用户绑定项目失败');
      }
    };
    getUserBindProject();

    /**
     * 退出登录
     */
    const logout = () => {
      ElMessageBox.confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除用户信息和token
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        router.push('/login');
        ElMessage.success('已退出登录');
      }).catch(() => {});
    };
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(userFrom) !== 'noLogo' ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(logoSrc),
        class: "admin-logo",
        alt: "Logo"
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "brand-text"
      }, [_createElementVNode("h1", {
        class: "admin-brand-title"
      }, "系统管理平台"), _createElementVNode("span", {
        class: "brand-subtitle"
      }, "城市消防 · 管理后台")], -1))]), _createElementVNode("div", _hoisted_5, [_createVNode(WorkspaceMenu, {
        name: userName.value,
        avatar: userAvatar.value,
        initials: userInitials.value,
        "show-logout": "",
        onLogout: logout
      }, null, 8, ["name", "avatar", "initials"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(AdminSidebar, {
        collapsed: isCollapsed.value,
        "onUpdate:collapsed": _cache[0] || (_cache[0] = $event => isCollapsed.value = $event),
        menus: _unref(menuList),
        "active-menu": activeMenu.value,
        "active-group": parentMenu.value ? String(parentMenu.value.menuId || parentMenu.value.id) : '',
        onSelect: handleSelect
      }, null, 8, ["collapsed", "menus", "active-menu", "active-group"]), _createElementVNode("main", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
          to: {
            path: '/ht'
          }
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("后台首页")])),
          _: 1,
          __: [2]
        }), parentMenu.value ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(parentMenu.value.name), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(pageTitle.value), 1)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            include: cachedViews.value
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
          _: 2
        }, 1024)]),
        _: 1
      })])])]), _createVNode(AlarmBall)]);
    };
  }
};